import { render, staticRenderFns } from "./cartConfirmationModal.vue?vue&type=template&id=60c7151e"
import script from "./cartConfirmationModal.vue?vue&type=script&lang=js"
export * from "./cartConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports